import React, { useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const COLORS = ["#22c55e", "#ef4444"];

const BookStatusPie = ({ active = 0, inactive = 0 }) => {
  const data = useMemo(
    () => [
      { name: "Active", value: active },
      { name: "Inactive", value: inactive },
    ],
    [active, inactive],
  );

  return (
    <div style={{ width: "100%", height: 320 }}>
      <ResponsiveContainer>
        <PieChart margin={{ top: 10, right: 40, left: 10, bottom: 10 }}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={70}
            outerRadius={110}
            paddingAngle={4}
          >
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i]} />
            ))}
          </Pie>

          <Tooltip />

          {/* ✅ LEGEND ON RIGHT */}
          <Legend
          //     layout="vertical"
          //     verticalAlign="middle"
          //     align="right"
          //     iconType="circle"
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BookStatusPie;
